import React from 'react';
import styled from 'styled-components';
import { Answer } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import { Report } from '../../../../NPOFeedback/SubmitReady/utils';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import Button from '@mui/material/Button';

interface LockReportProps {
  report: Report;
  answers: Answer[];
  isLoading: boolean;
  handlePressSection: (sectionId: number) => unknown;
  setIsReportInprogress: (show: boolean) => unknown;
  handlePressOption: (secId: number, optId: number) => unknown;
}

const StyledDiv = styled.div`
  padding-left: ${SPACERS.small};
  padding-right: ${SPACERS.small};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  gap: 16px;
`;

const LockReport: React.FC<LockReportProps> = ({ report }) => {
  const handleViewPublishedReport = () => {
      window.location.href = `/report/${report?.dbId}`;
  };
  return (
    <StyledDiv>
      <TrueImpactText variant="heading-page" align="center">
        This report is finalized
      </TrueImpactText>
      <TrueImpactText variant="body-large" align="center">
        No further actions required on this report.
      </TrueImpactText>
      <ButtonRow>
        <Button
          onClick={handleViewPublishedReport}
          variant="contained"
          color="primary"
          size="medium"
          className="cn-share-button"
        >
          View Report
        </Button>
      </ButtonRow>
    </StyledDiv>
  );
};

export default LockReport;
